export const CollaborativeExamPrep = {
  title: 'Collaborative Exam Prep',
  icon: '/static/templates_icons/CollaborativeExamPrep.svg',
  prompt: `
    <p class="pink-selectable">
      [This template provides a simple way for teachers to incorporate collaborative exam/test
      preparation into their classroom. Learn more about how to implement this activity in
      your classroom at <a target="_blank" href="https://parlayideas.com/templates/#exam-prep">https://parlayideas.com/templates/#exam-prep</a>]
    </p>
    <h3>Part 1 - Topic Assignments:</h3>
    <p class="pink-selectable">
      [Teacher comes up with list of key topics/questions/concepts that students are to
      explore for their exam review. One topic per student or group of students. Your choice.]
    </p>
    <p class="pink-selectable">
      &nbsp;&nbsp; 1. Topic/Question/Concept —> Student (or team) <br>
      &nbsp;&nbsp; 2. Topic/Question/Concept —> Student (or team) <br>
      &nbsp;&nbsp; 3. Topic/Question/Concept —> Student (or team) <br>
    </p>
    <h3>Part 2 - Student Submission:</h3>
    <p>
      Work alone <span class="pink-selectable">[or with your group]</span> to create one submission that explains the topic/concept that
      you were assigned. You can answer the question using a combination of text, images, videos,
      and links to external sources. Please write the name of your topic at the top of your submission.
    </p>
    <p>
      If in teams - pick one student to submit on behalf of the group and have the others “Skip to
      discussion” to join the conversation as observers.
    </p>
    <p>
      Remember that everyone is relying on each other to create thoughtful and thorough answers so
      we can all be ready for the <span class="pink-selectable">test/exam.</span> That doesn’t mean your answer has to be “perfect” (that’s
      what the peer feedback is for), but please use all the resources available to you to make your
      answer as complete and comprehensive as possible.
    </p>
    <h3>Part 3 - Peer Feedback:</h3>
    <p>
      After you join the discussion, pick at least 2 of the other submissions to ask questions and
      provide feedback. Please answer the guiding questions provided, and try to find a submission
      that doesn’t have any comments yet - it’s important for everyone to get feedback.
    </p>
    <p>
      Finally, don’t forget to read through ALL of the responses as you prepare for the test/exam.
    </p>
    <p class="pink-selectable">
      Recommended Feedback Questions (change in settings above):
      <br><br>
      &nbsp;&nbsp; 1. Do you have any questions about the content or concept in general? <br>
      &nbsp;&nbsp; 2. Do you have any additional ideas or thoughts you’d like to add? <br>
      &nbsp;&nbsp; 3. Can you connect this concept to another concept in the unit? <br>
    </p>
  `,
};


// WEBPACK FOOTER //
// ./src/app/components/modals/New_RoundTable/EditorMCE/Templates/Defaults/CollaborativeExamPrep.js